import { Property } from '@sales-app/api/GeoLocation/GeoLocation'

export function MapPopupAmenitiesList({ property }: { property: Property }) {
  return (
    <div className="cursor-default border-t border-grey-400 px-5">
      <h4 className="text-grey-800 mt-4 font-medium text-base leading-140">Featured Amenities</h4>
      <div className="grid grid-flow-row grid-cols-2 gap-x-4">
        {property.amenities.map((amenity, i) => {
          return (
            <p
              className="text-grey-800 overflow-hidden overflow-ellipsis border-b border-grey-300 py-3 text-sm leading-none"
              key={i}
            >
              {amenity}
            </p>
          )
        })}
      </div>
    </div>
  )
}
